import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IAppGrowthStatisticsVm } from '../app-growth-statistics-vm.model';
import { IGetStatisticsUm } from '../get-statistics-um.model';
@Injectable({ providedIn: 'root' })
export class AppGrowthStatisticsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/AppGrowthStatistics`;
  }
  post(model: IGetStatisticsUm): Observable<IAppGrowthStatisticsVm> {
    const headers = this.createHeaders();
    return this.http.post<IAppGrowthStatisticsVm>(this.baseUrl, model, { headers });
  }
  get(): Observable<IAppGrowthStatisticsVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    return this.http.get<IAppGrowthStatisticsVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
